"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _immutable = require("immutable");

var _utils = require("ComposeUI/lib/utils");

var _userInfo = _interopRequireDefault(require("hub-http/userInfo"));

var Auth = /*#__PURE__*/function () {
  (0, _createClass2.default)(Auth, [{
    key: "createInstance",
    value: function createInstance() {
      return new Auth();
    }
  }]);

  function Auth() {
    (0, _classCallCheck2.default)(this, Auth);
    this.data = {
      auth: null,
      gates: new _immutable.Set(),
      portal: null,
      user: new _immutable.Set()
    };
    this.initialized = false;
  }

  (0, _createClass2.default)(Auth, [{
    key: "init",
    value: function init() {
      var _this = this;

      if (this.initialized) {
        throw new Error('Auth Utils: Cannot be initialized twice. Use getInstance() if you ' + 'need to create multiple instances.');
      }

      this.initialized = true;
      return (0, _userInfo.default)().then(function (_ref) {
        var auth = _ref.auth,
            gates = _ref.gates,
            portal = _ref.portal,
            user = _ref.user;
        var data = {
          auth: auth,
          gates: (0, _utils.getRelevantGates)(gates),
          portal: portal,
          user: (0, _immutable.fromJS)(user)
        };
        _this.data = data;
        return data;
      });
    }
  }, {
    key: "get",
    value: function get() {
      return this.data;
    }
  }]);
  return Auth;
}();

var _default = new Auth();

exports.default = _default;
module.exports = exports.default;